// Vendors
import styled from 'styled-components';

const LoadingComponentStyled = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_300};
`;
LoadingComponentStyled.displayName = 'LoadingComponentStyled';

const LoadingBottomSideComponentStyled = styled(LoadingComponentStyled)`
  gap: ${({ theme }) => theme.spacing_230};
`;
LoadingBottomSideComponentStyled.displayName = 'LoadingBottomSideComponentStyled';

const LoadingBottomSideTitleComponentStyled = styled.div`
  display: flex;
`;
LoadingBottomSideTitleComponentStyled.displayName = 'LoadingBottomSideTitleComponentStyled';

export {
  LoadingComponentStyled,
  LoadingBottomSideComponentStyled,
  LoadingBottomSideTitleComponentStyled,
};
